export default "/static/explore/b946185d86a00c241a56a2bd371c89821aef0275/_next/static/images/thumbnail-gamer-c679875dc214b40b039b8f7ce032829e.png";